import { Component } from '@verndale/core';

class Accordion extends Component {
  setupDefaults() {
    this.dom = {
      $trigger: this.$el.find('.accordion__item-title')
    };

    const { hash } = window.location;

    if (hash) {
      const selectedItem = this.$el.find(`.accordion__item-title${hash}`);

      if (selectedItem) {
        this.toggleContent(selectedItem);
      }
    }
  }
  addListeners() {
    this.dom.$trigger.on('click', this.onTriggerClick.bind(this))
  }

  onTriggerClick(e) {
    const target = $(e.currentTarget);
    this.toggleContent(target);
  }

  toggleContent(item) {
    if (item.attr('aria-expanded') === 'true') {
      item.attr('aria-expanded', false);
      item.parent().next('.accordion__item-content').slideUp('fast');
      item.find('.plus-minus-toggle').addClass('collapsed');
    } else {
      item.attr('aria-expanded', true);
      item.parent().next('.accordion__item-content').slideDown('fast');
      item.find('.plus-minus-toggle').removeClass('collapsed');
    }
  }
}
export default Accordion;
